<script>
    import Box from './Box.svelte'
    import Icon from 'fa-svelte'
    import { faTimes as times } from '@fortawesome/free-solid-svg-icons/faTimes'
    import { faTwitter as twitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    let twitterLink = 'https://twitter.com/compose/tweet?url=stuckhome.io&text=' + encodeURIComponent('Fun activities to do while safe at home 🎉')

    function yesHandler() {
        dispatch('yes')
    }

    function noHandler () {
        dispatch('no')
    }

</script>

<style>
    main {
        display: grid;
        grid-template-columns: 1fr auto;
        grid-gap: 0 1rem;
    }

    h2 {
        grid-column: 1 / span 1;
    }

    p {
        grid-column: 1 / span 2;
    }

    icon {
        vertical-align: middle;
    }
</style>

<Box hoverable={false}>
    <main>
        <h2>Done 🎉</h2> 
        <div>
            <button on:click={noHandler} class='gray'>
                <icon>
                    <Icon icon={times}></Icon>
                </icon>
            </button>
        </div>
        <p>Thanks for helping the community stay busy while safe!</p>
        <!-- <button on:click={yesHandler} class='secondary'>Submit another activity</button>
        <button on:click={noHandler} class='secondary'>Close</button> -->
    </main>
    <span slot='left-accessory'>
        <a href={twitterLink}>
            <button on:click={noHandler} class='gray'>
                <icon>
                    <Icon icon={twitter}></Icon>
                </icon>
            </button>
        </a>
    </span>
    <span slot='right-accessory'>
        <button on:click={yesHandler}>Submit another</button>
    </span>
</Box>